import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import PlusIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/PlusIconPath";
import MinusIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/MinusIconPath";
import {
  ZoomControlContainer,
  ZoomControlPercentageBox,
} from "../styles/styles";
import { useTranslation } from "@coworker/locales";

interface ZoomControlProps {
  currentZoom: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  minZoom?: number;
  maxZoom?: number;
}

const commonButtonProps = {
  type: "image-overlay" as const,
  size: "small" as const,
  iconOnly: true as const,
};

export const ZoomControl = ({
  currentZoom,
  onZoomIn,
  onZoomOut,
  minZoom = 100,
  maxZoom = 500,
}: ZoomControlProps) => {
  const { t } = useTranslation();
  return (
    <ZoomControlContainer>
      <FixaButton
        {...commonButtonProps}
        aria-label={t("zoomOutAriaLabelString")}
        data-testid="zoomControlMinus"
        ssrIcon={MinusIconPath}
        onClick={onZoomOut}
        disabled={currentZoom <= minZoom}
      />
      <ZoomControlPercentageBox
        tabIndex={0}
        data-testid="zoomPercentageBox"
        aria-label={t("zoomLevelAriaLabelString", { zoomLevel: currentZoom })}
      >
        {currentZoom}%
      </ZoomControlPercentageBox>
      <FixaButton
        {...commonButtonProps}
        aria-label={t("zoomInAriaLabelString")}
        data-testid="zoomControlPlus"
        ssrIcon={PlusIconPath}
        onClick={onZoomIn}
        disabled={currentZoom >= maxZoom}
      />
    </ZoomControlContainer>
  );
};
